import React from "react";

function getWeekNumber(d) {
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return [d.getUTCFullYear(), Math.ceil(((d - yearStart) / 86400000 + 1) / 7)];
}

const currentWeek = getWeekNumber(new Date());

function getTuesdays(limitMonths = 12) {
  let tuesdays = [];
  let today = new Date();
  let d = new Date(today.getFullYear(), today.getMonth(), 1);

  while (d.getDay() !== 2) {
    d.setDate(d.getDate() + 1);
  }

  let monthsProcessed = 0;
  while (monthsProcessed < limitMonths) {
    let formattedDate = `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    let weekNo = getWeekNumber(d);

    if (formattedDate !== "4/3/2025") {
      tuesdays.push({
        date: formattedDate,
        week: weekNo[1],
        year: weekNo[0],
        dateObj: new Date(d),
      });
    }

    d.setDate(d.getDate() + 7);
    if (d.getMonth() !== (today.getMonth() + monthsProcessed) % 12) {
      monthsProcessed++;
    }
  }

  return tuesdays;
}

const tuesdays = getTuesdays();

function businessDaysBetween(startDate, endDate) {
  let count = 0;
  let current = new Date(startDate);
  current.setHours(0, 0, 0, 0);

  while (current < endDate) {
    let day = current.getDay();
    if (day !== 0 && day !== 6) {
      count++;
    }
    current.setDate(current.getDate() + 1);
  }

  return count;
}

let futureTuesdays = tuesdays.filter(
  (day) => day.week >= currentWeek[1] || (day.year > currentWeek[0] && day.week < 14)
);

if (futureTuesdays.length > 0) {
  let today = new Date();
  today.setHours(0, 0, 0, 0);

  let firstTuesday = futureTuesdays[0].dateObj;
  let daysToFirstTuesday = businessDaysBetween(today, firstTuesday);

  // Si hoy es martes, miércoles o jueves o si no hay al menos 3 días hábiles, saltamos al siguiente martes
  if (today.getDay() >= 2 && today.getDay() <= 4 || daysToFirstTuesday < 3) {
    futureTuesdays.shift();
  }
}

// Definiciones para pruebas en consola
window.getTuesdays = getTuesdays;
window.futureTuesdays = futureTuesdays;
window.businessDaysBetween = businessDaysBetween;

export default class CalendarQ extends React.Component {
  componentDidMount() {
    this.props.handleIsPastMonday(currentWeek);
  }

  render() {
    return (
      <div className="calendarQ">
        <h5 className="calendarQText">
          ¿Qué día quieres programar la reunión para Formación Integral?
        </h5>
        <h6>
          Recuerda que todas nuestras formaciones se realizan los martes de 10:00 a 13:00 aproximadamente.
        </h6>
        <ul className="ListOfTuesdays">
          {futureTuesdays
            .slice(this.props.isPastMonday, 7 + this.props.isPastMonday)
            .map((day) => (
              <li key={day.year + day.week} onClick={this.props.handleClick}>
                {day.date}
              </li>
            ))}
        </ul>
      </div>
    );
  }
}
